import { useState, useContext } from "react";
import CarouselVisCard from "./CarouselVisCard";
import { UserInfo, VisualCache } from "../helper/Context";
import { shallowCopy } from "../helper/Utils";
import { Row, Col } from "react-bootstrap";

const UploadResultDisplay = (props) => {
  const { result } = props;
  const [vis, setVis] = useState(result.payload || null);
  const { visCache, setVisCache } = useContext(VisualCache);

  const handleVisEdit = (editedVis) => {
    const tempVisCache = shallowCopy(visCache);
    tempVisCache[editedVis.id] = editedVis;
    setVisCache(tempVisCache);
    setVis(editedVis);
  };

  const handleVisDelete = (visId) => {
    const tempVisCache = shallowCopy(visCache);
    delete tempVisCache[visId];
    setVisCache(tempVisCache);
    setVis(null);
  };

  if (!result.success) {
    return (
      <div id="resource-upload-result">
        <h4 className="text-danger text-center">{result.payload}</h4>
      </div>
    );
  }

  return (
    <div id="resource-upload-result">
      <h4 className="text-success text-center mb-4">Success! Your new visual is ready.</h4>
      {vis ? (
        <Row className="justify-content-center">
          <Col xs={12} sm={8} md={6} lg={4}>
            <UserInfo.Consumer>
                {({ userInfo }) => (
                    <CarouselVisCard
                        vis={vis}
                        onVisEdit={handleVisEdit}
                        onVisDelete={handleVisDelete}
                        folders={[]} // No folders context here, pass empty array
                    />
                )}
            </UserInfo.Consumer>
          </Col>
        </Row>
      ) : (
        <h6 className="text-success text-center">Visual Deleted</h6>
      )}
    </div>
  );
};

export default UploadResultDisplay;
